module.exports = __webpack_public_path__ + "static/img/cpzx-top.1fd2cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cpzx-top.png
// module id = zjmU
// module chunks = 0